import a from "../toDate/index.js";
import o from "../_lib/requiredArgs/index.js";
function n(t) {
  o(1, arguments);
  var r = a(t), e = r.getDate();
  return e;
}
export {
  n as default
};
//# sourceMappingURL=index.js.map
